import { FC } from 'react';

import { IonSkeletonText } from '@ionic/react';

import { Card } from '../../Card/Card';
import { SkeletonFeed } from '../SkeletonFeed/SkeletonFeed';

import styles from '../Skeleton.module.scss';

interface SkeletonArticleProps {
  count?: number;
}

export const SkeletonArticle: FC<SkeletonArticleProps> = () => {
  return (
    <div className={styles.articleRoot}>
      <Card variant="flat" className={styles.baseRoot}>
        <Card.Thumb>
          {({ width, height }) => (
            <div style={{ width, height }}>
              <IonSkeletonText animated />
            </div>
          )}
        </Card.Thumb>
        <Card.Content>
          <div className={styles.baseText}>
            <IonSkeletonText className={styles.skeleton} animated />
            <IonSkeletonText className={styles.skeleton} animated />
          </div>
        </Card.Content>
      </Card>
      <div>
        <SkeletonFeed count={1} />
      </div>
    </div>
  );
};
